import { types, successAction } from "@authzsvc/api-lib";

const initialState = {};

const identityReducer = (state = initialState, action) => {
  switch (action.type) {
    case successAction(types.GET_IDENTITY):
      return action.payload.data;
    default:
      return state;
  }
};
export default identityReducer;
